import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SsoService} from '../sso/sso.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {UserService} from '../../services/user/user.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {User} from '../../services/user/user';
import {Subscription} from 'rxjs';
import { environment } from 'src/environments/environment';
import OktaSignIn, {WidgetOptions} from '@okta/okta-signin-widget';
import * as fileSaver from "file-saver";

@Component({
    selector: 'app-okta',
    templateUrl: './okta.component.html',
    styleUrls: ['./okta.component.css'],
    standalone: false
})


export class OktaComponent implements OnInit, OnDestroy {

  constructor(
    private ssoService: SsoService,
    private strloader: LoadingService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private alertService: AlertService) {
    // this.signIn = oktaAuth;
    this.loader = strloader;
    this.user_subscription = this.userService.getCurrentUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        // removes user from session table
        this.userService.removeSession(this.currentUser);
      }
    });
  }

  public static config: WidgetOptions = {
    baseUrl: environment.oktaBaseUrl,
    issuer: environment.oktaIssuer,
    redirectUri: environment.oktaRedirectUri,
    clientId: environment.oktaClientId,
    useClassicEngine: true,
    scopes: ['openid', 'profile', 'email'],
    authParams: {
      issuer:  environment.oktaIssuer,
      responseType: 'code',
      responseMode: 'query',
      pkce: false,
      display: 'page'
    },

    features: {
      registration: false,                 // Enable self-service registration flow
      rememberMe: false,                   // Setting to false will remove the checkbox to save username
      multiOptionalFactorEnroll: true,  // Allow users to enroll in multiple optional factors before finishing the authentication flow.
      selfServiceUnlock: false,          // Will enable unlock in addition to forgotten password
      // smsRecovery: true,                // Enable SMS-based account recovery
      // callRecovery: true,               // Enable voice call-based account recovery
      router: false,                       // Leave this set to true for the API demo
      showPasswordToggleOnSignInPage: true,
    },
    language: 'en',
    i18n: {
      'en': {
        'primaryauth.title': 'Enter your email and password to login',
        'primaryauth.submit': 'Login',
        'primaryauth.username.placeholder': 'Enter your email address',
        'primaryauth.username.tooltip': ' ',
        'primaryauth.password.tooltip': ' ',
        'error.username.required': 'Please enter your email',
        'error.password.required': 'Please enter a password',
        'errors.E0000004': 'Sign in failed.  Invalid email address/password provided, or you may not be a registered user of this application.  Please check your credentials and try again, or register for an account!',
        'password.expired.title': 'Your password has expired',
        'error.auth.lockedOut': 'Your account has been locked for 30 minutes, please try later',
        'password.oldPassword.placeholder': 'Old/Temporary password',
        'mfa.sendEmail': 'Send verification email'
      }
    },
    helpLinks: {
      forgotPassword: './forgotpassword',
      help: './help',
    }
  };
  public static configtemp: WidgetOptions = {
    baseUrl: environment.oktaBaseUrl,
    useClassicEngine: true,
    issuer: environment.oktaIssuer,
    redirectUri: environment.oktaRedirectUri,
    clientId: environment.oktaClientId,

    authParams: {
      issuer:environment.oktaIssuer,
      responseType: 'code',
      display: 'page',
      scopes: ['openid', 'email', 'profile'],
    },
    features: {
      registration: false,                 // Enable self-service registration flow
      rememberMe: false,                   // Setting to false will remove the checkbox to save username
      multiOptionalFactorEnroll: true,  // Allow users to enroll in multiple optional factors before finishing the authentication flow.
      selfServiceUnlock: false,          // Will enable unlock in addition to forgotten password
      // smsRecovery: true,                // Enable SMS-based account recovery
      // callRecovery: true,               // Enable voice call-based account recovery
      router: false,                       // Leave this set to true for the API demo
      showPasswordToggleOnSignInPage: true,
    },
    language: 'en',
    i18n: {
      'en': {
        'primaryauth.title': 'Enter your email and password to login',
        'primaryauth.submit': 'Login',
        'primaryauth.username.placeholder': 'Enter your email address',
        'primaryauth.password.placeholder': 'Temporary Password',
        'primaryauth.username.tooltip': ' ',
        'primaryauth.password.tooltip': ' ',
        'error.username.required': 'Please enter your email',
        'error.password.required': 'Please enter a password',
        'errors.E0000004': 'Sign in failed.  Invalid email address/password provided, or you may not be a registered user of this application.  Please check your credentials and try again, or register for an account!',
        'password.expired.title': 'Your password has expired',
        'error.auth.lockedOut': 'Your account has been locked for 30 minutes, please try later',
        'password.oldPassword.placeholder': 'Old/Temporary password',
        'mfa.sendEmail': 'Send verification email'
      }
    },
    helpLinks: {
      forgotPassword: './forgotpassword',
      help: './help',
    }
  };

  currentUser: User | any;
  private user_subscription: Subscription;

  signIn;
  isUserAgentChrome;
  widget = new OktaSignIn(OktaComponent.config);
  public redirectUrl: string;
  ssoInitResult: string;
  returnUrl: string;
  email = '';
  otp: number;
  tempPasswordExpired: boolean;
  errorMessage: string;
  loader;
  broadCastMessages = [];

  ngOnInit() {
    this.userService.getBroadcastMsg().subscribe(res => {
      this.broadCastMessages = res;
    });
    this.isUserAgentChrome = /chrome/i.test(window.navigator.userAgent);
    this.userService.logout('okta');
    // Get the request parameter
    if (this.router.url.indexOf('tempsignon') > -1) {
      this.widget = new OktaSignIn(OktaComponent.configtemp);
    } else {
      this.widget = new OktaSignIn(OktaComponent.config);
    }
    this.route.queryParams.subscribe(params => {
      this.errorMessage = '';
      this.tempPasswordExpired = false;
      console.log('Params ; ' + params);
      if (params) {
        console.log('Got params...');
        if (params['email']) {
          console.log('received email parameter', params['email']);
          this.email = params['email'];
        }

        if (params['otp']) {
          console.log('received otp parameter', params['otp']);
          this.otp = params['otp'];
        }

        if (params['error']) {
          console.log('received error parameter', params['error']);
          this.errorMessage = params['error'];
          // this.alertService.warn(params['error']);
        }

      }
    });

    console.log('calling this.widget ', this.widget);

    localStorage.removeItem('currentUser');

    this.widget.renderEl
    ({
        el: '#okta-sign-in'
      },
      (res) => {

        console.log('res.status is ', res.status);
        if (res.status === 'SUCCESS') {
          // this.signIn.loginRedirect('/', { sessionToken: res.session.token });
          // Hide the widget
          // this.widget.hide();
        }
      },
      (err) => {
        console.log('error rendering widget ', err);
        throw err;
      }
    );
  }

  initiateSSO() {
    // reset login status
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('currentUser');
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loader.show();
    setTimeout(() => {
      this.ssoService.initiateSSO()
        .subscribe(
          ssoInitResult => {
            this.ssoInitResult = ssoInitResult;
            console.log('sso Url ' + this.ssoInitResult);
            this.redirectUrl = this.ssoInitResult;
            if (this.redirectUrl) {
              window.location.href = this.redirectUrl;
            }
            this.loader.hide();
          }, (error) => {
            this.loader.hide();
            // this.alertService.error(Constant.api_error);
          });
    }, 2000);
    this.loader.hide();
  }

  downloadFaq() {
    fileSaver.saveAs('../../../assets/templates/FAQ.pdf', 'FAQ.pdf');
  }

  ngOnDestroy(): void {
    if (this.user_subscription) {
      this.user_subscription.unsubscribe();
    }
  }
}
